import { render, staticRenderFns } from "./couponDetail.vue?vue&type=template&id=43171981&scoped=true&"
import script from "./couponDetail.vue?vue&type=script&lang=js&"
export * from "./couponDetail.vue?vue&type=script&lang=js&"
import style0 from "./couponDetail.vue?vue&type=style&index=0&id=43171981&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43171981",
  null
  
)

component.options.__file = "couponDetail.vue"
export default component.exports